import type { HTMLAttributes } from 'react';
import styles from './Tag.module.css';

interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'cyan' | 'magenta' | 'green';
  size?: 'sm' | 'md';
}

export default function Tag({
  variant = 'default',
  size = 'sm',
  className = '',
  children,
  ...props
}: TagProps) {
  return (
    <span
      className={`${styles.tag} ${styles[variant]} ${styles[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
